import React from 'react';
import PropTypes from 'prop-types';

import SignupForm from './SignupForm';
import { dispatchEvent } from 'helpers/analytics/AnalyticsEventDispatcher';

const styles = {
  'modal': 'email-signup-modal',
  'modal__success': 'email-signup-modal__success',
  'modal__header': 'email-signup-modal__header',
  'modal__close': 'email-signup-modal__close',
  'modal__content': 'email-signup-modal__content',
  'success__tick': 'success__tick',
  'success__text': 'success__text'
};


function setPageJlData() {
  if(!window.jlData.page) {
    window.jlData.page = {};
  }

  if (!window.jlData.page.pageInfo) {
    window.jlData.page.pageInfo = {};
  }

  const previousPageType = window.jlData.page.pageInfo.pageType;
  const previousPageName = window.jlData.page.pageInfo.pageName;

  window.jlData.page.pageInfo =
    { breadCrumb: [
      {
        value: 'email sign up',
        clickable: 1,
      },
    ],
    pageName: 'jl:email sign up',
    pageType: 'lightbox',
    previousPageType,
    previousPageName,
    };
}

function dispatchAnalytics(action) {
  setPageJlData();
  dispatchEvent('dataStateChange', { action });
}

const FormPage = ({ onSuccess }) => (
  <div>
    <SignupForm onSuccess={onSuccess} />
    <p className="privacy_notice">We treat your personal data with care, view our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice">privacy notice</a> here.</p>
  </div>
);

const SuccessPage = ({ onClose }) => (
  <div>
    <div className={styles.success__tick} />
    <p aria-live="polite" className={styles.success__text}>You're now signed up and your first email will be on its way to you soon.</p>
    <button className="button" type="submit" onClick={onClose}>Continue shopping</button>
  </div>
);

class SignupModal extends React.Component {
  constructor() {
    super();
    this.state = {
      submitted: false,
    };

    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    dispatchAnalytics('pageload.signup');
  }

  formSubmitted() {
    dispatchAnalytics('signup.submit');
    this.setState({ submitted: true });

    // update LocalStorage to ensure the customer doesn't see the banner again
    const supportsLocalStorage = window.localStorage && typeof window.localStorage.setItem === 'function';
    if (supportsLocalStorage) {
      // this is consumed in cms-header-banner.hbs
      window.localStorage.setItem('Email Signup Completed', 'true');
    }
  }

  closeSuccessModal() {
    dispatchAnalytics('signup.continue-shopping');
    this.props.onClose();
  }

  closeModal() {
    dispatchAnalytics('signup.close');
    this.props.onClose();
  }

  render() {
    const formSubmitted = this.state.submitted;
    const modalTitle = formSubmitted ? 'Thank you' : 'Sign me up for emails';
    const renderPage = formSubmitted ? (
      <SuccessPage onClose={() => this.closeSuccessModal()} />
    ) : (
      <FormPage onSuccess={() => this.formSubmitted()} />
    );

    /*
      Note:
      The closeModal button below is given aria-hidden because currently the screenreader user isn't told they're in a modal, so "closing" it doesn't make sense.
      When the reader gets to the bottom of our modal it continues to read the page that comes after it, so from the user's perspective they aren't in a modal.

      Also both the title and the success body have aria-live values so that they are read out when you complete the form successfully.
    */

    return (
      <div className="overlay show">
        <a className="cancel" onClick={this.closeModal}></a>
        <div className={'popup' + (formSubmitted ? ' success' : '')}>
          <div className={styles['modal__header']}>
            <h2 aria-live="assertive" className={styles['modal__title']}>{modalTitle}</h2>
            <button onClick={this.closeModal} className={styles['modal__close']} title="Close" aria-hidden="true">×</button>
          </div>
          <div className={!formSubmitted ? styles.modal : styles.modal__success}>
            <div className={styles.modal__content}>{renderPage}</div>
          </div>
        </div>
      </div>
    );
  }
}

SignupModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SignupModal;
